<div class="error-content">
    <div class="error-text">404 Oops!</div>
    <p>The page you are looking for appears to be missing.<br>We're really sorry!</p>
    <a href="/admin" class="button">GO TO HOME PAGE</a>
</div>